import { Box, Grid, Typography, styled } from "@mui/material";

import { ContainedButton } from "@/common";
import { tokens } from "@/tokens";

export const UploadContainerMain = styled(Grid)(() => ({
  border: `1px solid ${tokens.border.default}`,
  marginTop: "unset !important",
  width: "100% !important",
  padding: "18px",
  alignItems: "flex-start !important",
  margin: "auto",
  marginBottom: "20px",
}));

export const UploadDetails = styled("div")(() => ({
  display: "flex",
  gap: "10px",
}));

export const UploadProgressContainer = styled(Box)(() => ({
  width: "100%",
  position: "relative",
  display: "flex",
  alignItems: "center",

  "& > span": {
    borderRadius: "4px",
    height: "8px",

    "& > span": {
      borderRadius: "4px",
    },
  },
}));

export const UploadProgressText = styled(Typography)(() => ({
  marginLeft: "20px !important",
  minWidth: "35px",
}));

export const UploadActions = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));

export const UploadSize = styled(Typography)(() => ({
  color: "rgba(0, 0, 0, 0.54)",
}));

export const ProgressMain = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "end",
}));

export const ChipStyle = styled(Typography)(() => ({
  color: tokens.text.secondary,
  backgroundColor: `${tokens.text.secondary}33`,
  borderRadius: tokens.radius.sm,
  padding: "4px",
}));

export const StyledContainedButton = styled(ContainedButton)(() => ({
  width: "100% !important",
  borderRadius: `${tokens.radius.sm} !important`,
  borderColor: tokens.border.default,
}));

export const ContainerHeading = styled("div")({
  backgroundColor: tokens.brand.primary,
  borderRadius: tokens.radius.lg,
  padding: "25px",
  position: "relative",
  "& svg": {
    color: tokens.bg.surface,
  },

  "& h6": {
    marginTop: "10px",
    fontWeight: tokens.fontWeight.normal,
  },
});
